/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var CoverageAmountEnum;

(function (CoverageAmountEnum) {
  CoverageAmountEnum["STATUTORY_LIMIT"] = "statutory_limit";
  CoverageAmountEnum["OTHER"] = "other";
})(CoverageAmountEnum || (CoverageAmountEnum = {}));